import { useEffect, useState } from 'react';

export function useScrolled(threshold: number = 20): boolean {
  const [scrolled, setScrolled] = useState<boolean>(
    typeof window !== 'undefined' && window.scrollY > threshold
  );

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > threshold;
      setScrolled((prev) => (prev === isScrolled ? prev : isScrolled));
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return scrolled;
}
